import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC, useCallback, useState } from "react";
import { config } from "../config";
import { useApiClient } from "@hostingbv/lib/src/api";
import { useRefresh } from "../../../lib/src/components/RefreshController";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";
import { MailDomain } from "../../../lib/src/api/partner/models/MailDomain";
import { Input } from "@hostingbv/lib/src/components/form/Input";


export const AddMailUserModal: FC<{ domain: MailDomain }> = ({ domain }) => {
  const { partnerClient } = useApiClient(config)
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!
  const refresh = useRefresh()
  const [username, setUserName] = useState('')
  const [password, setPassword] = useState('')

  const [error, setError] = useState('')

  const save = useCallback(async () => {
    const deployment = await partnerClient.addUserToMailDomain(domain.id, `${username}@${domain.displayName}`, password).then(result => {
      if (!result.success) {
        setError(result.error)
        throw new Error(result.error)
      }
      return result.data
    })
    if (deployment.id) {
      await awaitNextDeploymentFinished(deployment.id)
    }
    refresh()
  }, [domain, username, password])

  return <>
    <form onSubmit={() => save()} className={"space-y-4 flex-1"}>
      <div className={"flex items-end"}>
        <Input label={'Username'} type={"text"} value={username} onChange={setUserName} />
        <div className={"h-10 flex items-center font-medium text-slate-800 ml-2"}>@{domain.displayName}</div>
      </div>
      <Input label={'Password'} type={"password"} value={password} onChange={setPassword} />
      {error.length > 0 && <div className={"font-medium text-red-600"}>
        {error}
      </div>}
    </form>
    <ModalFooter text={"Add"} onSubmit={save} />
  </>
}
